<template>
	<div class="auction-select">

		<b-dropdown id="auction-select"
					no-flip
					:text="selectedText"
					variant="info"
					class="w-100"
					v-bind:class="{ 'no-border-radius': removeBorderRadius == true }">

			<b-dropdown-item v-for="auction in auctions"
							:key="auction.id"
							@click="clickLink(auction)"
							class="m-0">
				{{ auction.title }}
			</b-dropdown-item>

		</b-dropdown>
	</div>
</template>

<script>
import AuctionService from '@/services/auction-service.js'
import { isNil } from 'lodash';
import {
	mapActions,
	mapGetters
} from 'vuex'

export default {
	props: {
		noBorderRadius: {
			type: Boolean,
			default: true
		},
		reset: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			removeBorderRadius: true
		}
	},
	mounted() {
		if (this.noBorderRadius == false) this.removeBorderRadius = this.noBorderRadius;
		this.initData();
	},
	beforeRouteUpdate(to, from, next) {
		if (to.path !== from.path) this.initData();
		next();
	},
	computed: {
		...mapGetters([
			'activeAuction',
			'auctions'
		]),
		selectedText() {
			if (!this.activeAuction.title || this.reset) {
				return 'Selecteer veiling';
			}

			return this.activeAuction.title;
		}
	},
	methods: {
		...mapActions([
			'getAuctions',
			'setActiveAuction'
		]),
		initData() {
			this.getAuctions();
		},
		clickLink(auction) {
			this.setActiveAuction(auction);
			this.$router.push('/auction/' + auction.id);
		}
	}
}
</script>

<style lang="scss">
.no-border-radius {
    .dropdown-toggle {
        border-radius: 0 !important;
    }
}
.auction-select {
    .dropdown-menu {
        background-color: #6e7277!important;
        width: 100%!important;
		
        a {
            width: 100%;
        }
    }

	.dropdown-item {
		padding: 1rem 2rem;
	}
}
</style>



// WEBPACK FOOTER //
// AuctionSelect.vue?b7dd3f0a